import * as React from 'react'
import { MuiTextFieldFormik } from '@sales-center/components'
import MenuItem from '@mui/material/MenuItem'
import { Field } from 'formik'
import { useData } from '../hooks'

export function TypeSelector() {
  const { activityTypes } = useData()

  return (
    <Field
      required
      component={MuiTextFieldFormik}
      disabled={false}
      fullWidth
      label="Activity Type"
      margin="normal"
      name="activityTypeId"
      select
      size="small"
      data-test-id={`activity-form-type-selector`}
      inputProps={{ 'data-test-id': 'activity-form-type-selector-input' }}
    >
      {activityTypes.map((type) => (
        <MenuItem value={type.id} key={type.id}>
          {type.name}
        </MenuItem>
      ))}
    </Field>
  )
}
